module.exports = __webpack_public_path__ + "images/icons_v2/auto-ship-11806e83.svg";